import * as tslib_1 from "tslib";
import { TextField } from './text_field';
var TextBox = /** @class */ (function (_super) {
    tslib_1.__extends(TextBox, _super);
    function TextBox(param) {
        return _super.call(this, param) || this;
    }
    TextBox.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "TextBox" });
    };
    TextBox.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return TextBox;
}(TextField));
export { TextBox };
//# sourceMappingURL=text_box.js.map